module.exports = __webpack_public_path__ + "static/img/home05.7ef2bd75.png";